import React from "react";
import { Tabs, Card } from "antd";
import Styled from "styled-components";

const Styledtab = Styled.div`

.ant-tabs-tab {

    font-size: 16px !important;
    font-weight: 500 !important;
    color: #5F6D8C !important;
    padding: 10px;
  }
  .ant-tabs-tab-active  {
    color: #2C963D !important;
    background-color: #F1F1F1 !important;
    border-radius: 25px;
    outline:none!important;
  }
.ant-tabs-nav::before {
  border-bottom: none !important;
}
.ant-tabs-tab-active .ant-tabs-tab-btn {
color: #2C963D !important;
}
.ant-tabs-ink-bar {
  display: none !important;
} 
// `;
const TabContent = ({ content }) => {
  return <div>{content}</div>;
};

const TabItem = ({ label, content }) => {
  return {
    key: label.toLowerCase().replace(/\s+/g, "-"),
    label: label,
    children: <TabContent content={content} />,
  };
};

const Tab = ({ defaultActiveKey, items, onChange }) => {
  return (
    <>
      <Styledtab>
        {/* <Card className='m-4 ' > */}
        <Tabs
          defaultActiveKey={defaultActiveKey}
          items={items}
          onChange={onChange}
          inkBarColor={"red"}
          className="verticalItemMargin"
        />
        {/* </Card> */}
      </Styledtab>
    </>
  );
};

export { Tab, TabItem, TabContent };
